module.exports = __webpack_public_path__ + "static/media/3full-min.a2aa1f52.png";